"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = exports.Gradient = exports.Text = exports.Outline = exports.Solid = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var colors = _interopRequireWildcard(require("./setColors"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Solid = _styledComponents.default.button.attrs(function (_ref) {
  var color = _ref.color,
      theme = _ref.theme,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      marginLeft = _ref.marginLeft,
      marginRight = _ref.marginRight,
      size = _ref.size;
  return {
    colors: colors.solid(color, theme.color),
    marginBottom: theme.margin[marginBottom] ? theme.margin[marginBottom] : theme.margin.none,
    marginTop: theme.margin[marginTop] ? theme.margin[marginTop] : theme.margin.none,
    marginLeft: theme.margin[marginLeft] ? theme.margin[marginLeft] : theme.margin.none,
    marginRight: theme.margin[marginRight] ? theme.margin[marginRight] : theme.margin.none,
    size: size || 'medium',
    style: null
  };
}).withConfig({
  componentId: "i7a2am-0"
})(["display:inline-block;align-self:flex-start;user-select:none;vertical-align:middle;outline:none;transition:0.2s all linear;position:relative;overflow:hidden;word-spacing:initial;transform:scale(0,0,0);text-shadow:none;text-align:center;", " &:after{content:'';display:block;position:absolute;width:100%;height:100%;top:0;left:0;pointer-events:none;background-repeat:no-repeat;background-position:50%;transform:scale(10,10);opacity:0;transition:transform 0.5s,opacity 1s;}&:active{&:after{transform:scale(0,0);opacity:0.2;transition:0s;}}"], function (_ref2) {
  var colors = _ref2.colors,
      size = _ref2.size,
      marginTop = _ref2.marginTop,
      marginRight = _ref2.marginRight,
      marginBottom = _ref2.marginBottom,
      marginLeft = _ref2.marginLeft,
      shadow = _ref2.shadow,
      fluid = _ref2.fluid,
      theme = _ref2.theme;
  return "\n    border: 1px solid ".concat(colors.borderColor, ";\n    background: ").concat(colors.background, ";\n    color: ").concat(colors.textColor, ";\n    margin: ").concat(marginTop, " ").concat(marginRight, " ").concat(marginBottom, " ").concat(marginLeft, ";\n    padding: ").concat(theme.button.size[size].padding, ";\n    font-size: ").concat(theme.button.size[size].fontSize, ";\n    font-weight: ").concat(theme.button.fontWeight, ";\n    font-family:  ").concat(theme.typography.fontFamily[0], ";\n    line-height: ").concat(theme.button.size[size].lineHeight, ";\n    text-align: ").concat(theme.button.textAlign, ";\n    border-radius: ").concat(theme.borderRadius, ";\n\n    ").concat(fluid && "\n      width: 100%;\n      display: block;\n    ", "\n\n    ").concat(shadow && "\n      box-shadow: ".concat(theme.button.size[size].shadow, " rgba(").concat(colors.rgb, ", 0.6);\n      &:hover {\n        box-shadow: ").concat(theme.button.size[size].shadowH, " rgba(").concat(colors.rgb, ", 0.6);\n        transform: translateY(-2px);\n        text-decoration: none !important;\n      }\n    "), "\n\n    &:disabled {\n      background: ").concat(theme.color.neutral300, ";\n      color: ").concat(theme.color.neutral600, ";\n      transform: translateY(0px);\n\n      ").concat(shadow && "\n        box-shadow: ".concat(theme.button.size.medium.shadow, " rgba(110, 110, 110, 0.6);\n      "), "\n\n      & svg {\n        fill: ").concat(theme.color.neutral600, ";\n      }\n    }\n\n    & svg {\n      fill: ").concat(colors.textColor, ";\n    }\n\n    &:hover {\n      text-decoration: none;\n      background: ").concat(colors.hover.background, ";\n      border-color: ").concat(colors.hover.borderColor, ";\n      color: ").concat(colors.hover.textColor, ";\n\n      & svg {\n        fill: ").concat(colors.hover.textColor, ";\n      }\n    }\n\n    &:after {\n      background-image: radial-gradient(circle, ").concat(theme.color.neutral950, " 10%, transparent 10%);\n    }\n  ");
});

exports.Solid = Solid;
var Outline = (0, _styledComponents.default)(Solid).attrs(function (_ref3) {
  var color = _ref3.color,
      theme = _ref3.theme;
  return {
    colors: colors.outline(color, theme.color)
  };
}).withConfig({
  componentId: "i7a2am-1"
})([""]);
exports.Outline = Outline;
var Text = (0, _styledComponents.default)(Solid).attrs(function (_ref4) {
  var color = _ref4.color,
      theme = _ref4.theme;
  return {
    colors: colors.text(color, theme.color)
  };
}).withConfig({
  componentId: "i7a2am-2"
})([""]);
exports.Text = Text;
var Gradient = (0, _styledComponents.default)(Solid).attrs(function (_ref5) {
  var color = _ref5.color,
      theme = _ref5.theme;
  return {
    colors: colors.gradient(color, theme.gradient)
  };
}).withConfig({
  componentId: "i7a2am-3"
})(["border:none;", ""], function (_ref6) {
  var size = _ref6.size,
      theme = _ref6.theme;
  return "\n    line-height: ".concat(parseInt(theme.button.size[size].lineHeight.replace(/[^0-9]/g, '')) + 2, "px;\n  ");
});
exports.Gradient = Gradient;
var Link = (0, _styledComponents.default)(Solid).attrs(function (_ref7) {
  var color = _ref7.color,
      theme = _ref7.theme;
  return {
    colors: colors.link(color, theme.color),
    shadow: null
  };
}).withConfig({
  componentId: "i7a2am-4"
})(["padding:0;&:after{display:none;}"]);
exports.Link = Link;
Solid.propTypes = {
  size: _propTypes.string,
  appearance: _propTypes.string,
  fullWidth: _propTypes.bool,
  shadow: _propTypes.bool,
  gradient: _propTypes.number
};